import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectIsEditMod,
  selectIsUndoModal,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { actualHousingOption, dataSorting, findKeyBaseOnValue } from '../../ModificationsUtils';
import { getFilteredOptions, updateStandardAmount } from './HousingUtility';

export const ActualHousingType = () => {
  const { control, getValues, setValue, clearErrors, setError, register, watch } = useFormContext();
  const { t } = useTranslation();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  const currentModDetails = useSelector(selectCurrentModDetails);
  register('actualHousingTypeId');
  const actualHousingType = 'actualHousingType';
  const ahtValue = watch(actualHousingType);
  const getId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(actualHousingOption, value);
    return selectedOption.Id;
  };
  const onSelectionChange = (value?: string) => {
    setValue(actualHousingType, value);
    setValue('actualHousingTypeId', getId(value));

    updateStandardAmount(currentModDetails, setValue, getId(value));
    if (value) {
      clearErrors(actualHousingType);
    }
  };

  useEffect(() => {
    if (ahtValue) {
      setValue('actualHousingTypeId', getId(ahtValue));
      updateStandardAmount(currentModDetails, setValue, getId(ahtValue));
      clearErrors(actualHousingType);
    } else {
      setError(actualHousingType, {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [clearErrors, dispatch, isUndoModal, setError, setValue, ahtValue, currentModDetails]);

  return (
    <Controller
      control={control}
      rules={{
        required: true,
      }}
      name={actualHousingType}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={actualHousingType}
          label={t('placement.placementMods.actualHousingType')}
          standard={true}
          options={dataSorting(getFilteredOptions(currentModDetails, getValues('housingProviderId'))) ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(actualHousingType) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling || !getValues('housingProviderId')}
          {...rest}
        ></FormInputDropdown>
      )}
    />
  );
};
